import { DITypes } from "@/core/@types/types";
import type { IToastNotification } from "@/core/composables/notification/types";
import { IHttpResponse } from "@/core/services/protocols/types";
import { inject, injectable } from "inversify";
import "reflect-metadata";
import { IDefaultHorizonsResponse } from "./types";

@injectable()
export abstract class FinancasGatewayError {
  constructor(
    @inject(DITypes.NOTIFICATION)
    readonly notification: IToastNotification<string>
  ) {}

  readonly DEFAULT_ERROR = "Ocorreu um erro inesperado";

  hasError<T>(response: IHttpResponse<IDefaultHorizonsResponse<T>>) {
    return response.statusCode !== 200 || response.body?.code !== 200;
  }

  handleErrors<T>(
    response: IHttpResponse<IDefaultHorizonsResponse<T>>,
    msg?: string
  ): void {
    const errors = response.body?.errors;
    const hasErrorList = (errors?.length || 0) > 0;

    if (!hasErrorList) {
      this.notification.showNotification(msg || this.DEFAULT_ERROR, {
        type: "error",
        timeout: 3000
      });

      return;
    }

    return errors?.forEach((error) =>
      this.notification.showNotification(error.message, {
        type: "error",
        timeout: 3000
      })
    );
  }

  static handleExceptionError(msg?: string) {
    const detaultError = "Ocorreu um erro inesperado";
    void import("@/core/di")
      .then(({ diContainer }) => {
        diContainer
          .get<IToastNotification<string>>(DITypes.NOTIFICATION)
          .showNotification(msg || detaultError, {
            type: "error",
            timeout: 4000
          });
      })
      .catch(() => undefined);
  }
}
